export const CONDITION_STATUSES = [
    'Kiváló',
    'Jó',
    'Megfelelő',
    'Cserére szorul',
    'Ismeretlen',
];
const fallbackConditionSheet = {
    tires: {
        frontLeft: { status: 'Jó', treadDepthMm: '5,8', lastChanged: '2026-10-15', note: 'Normál kopás, egyenletes futás' },
        frontRight: { status: 'Jó', treadDepthMm: '5,8', lastChanged: '2026-10-15', note: 'Normál kopás, egyenletes futás' },
        rearLeft: { status: 'Jó', treadDepthMm: '6,0', lastChanged: '2026-10-15', note: 'Normál kopás, egyenletes futás' },
        rearRight: { status: 'Jó', treadDepthMm: '6,0', lastChanged: '2026-10-15', note: 'Normál kopás, egyenletes futás' },
    },
    suspension: { status: 'Jó', lastChanged: '2026-02-10', note: 'Átvizsgálva, normál használati állapotban' },
    brakes: { status: 'Jó', lastChanged: '2026-02-10', note: 'Fékhatás rendben, kopás normál tartományban' },
    oilChange: { status: 'Kiváló', lastChanged: '2026-02-10', note: 'Olaj és szűrők cserélve' },
    timingService: { status: 'Jó', lastChanged: '2026-02-10', note: 'Ellenőrizve, rendellenes zaj nincs' },
    brakeFluid: { status: 'Jó', lastChanged: '2026-08-20', note: 'Fékolaj ellenőrizve, érték rendben' },
    other: { status: 'Jó', lastChanged: '2026-02-10', note: 'Általános diagnosztika hibamentes' },
};
const conditionSheetsById = {
    '1': {
        tires: {
            frontLeft: { status: 'Jó', treadDepthMm: '6,2', lastChanged: '2026-11-12', note: 'Michelin nyári gumi, egyenletes kopás' },
            frontRight: { status: 'Jó', treadDepthMm: '6,1', lastChanged: '2026-11-12', note: 'Michelin nyári gumi, egyenletes kopás' },
            rearLeft: { status: 'Kiváló', treadDepthMm: '6,8', lastChanged: '2026-11-12', note: 'Hátsó tengelyen frissebb mintázat' },
            rearRight: { status: 'Kiváló', treadDepthMm: '6,7', lastChanged: '2026-11-12', note: 'Hátsó tengelyen frissebb mintázat' },
        },
        suspension: { status: 'Jó', lastChanged: '2026-02-18', note: 'Átvizsgálva, kopogásmentes futómű' },
        brakes: { status: 'Jó', lastChanged: '2026-02-18', note: 'Első fékbetétek kb. 70%-os állapotban' },
        oilChange: { status: 'Kiváló', lastChanged: '2026-01-20', note: '0W-20 motorolaj és szűrők cserélve' },
        timingService: { status: 'Kiváló', lastChanged: '2026-01-20', note: 'Láncos vezérlés, rendellenes zaj nincs' },
        brakeFluid: { status: 'Jó', lastChanged: '2026-07-05', note: 'Fékolaj csere igazolt' },
        other: { status: 'Jó', lastChanged: '2026-02-18', note: 'Hibrid rendszer diagnosztika hibamentes' },
    },
    '2': {
        tires: {
            frontLeft: { status: 'Megfelelő', treadDepthMm: '4,7', lastChanged: '2026-10-03', note: 'Continental nyári gumi, még használható' },
            frontRight: { status: 'Megfelelő', treadDepthMm: '4,6', lastChanged: '2026-10-03', note: 'Continental nyári gumi, még használható' },
            rearLeft: { status: 'Jó', treadDepthMm: '5,4', lastChanged: '2026-10-03', note: 'Egyenletes kopáskép' },
            rearRight: { status: 'Jó', treadDepthMm: '5,3', lastChanged: '2026-10-03', note: 'Egyenletes kopáskép' },
        },
        suspension: { status: 'Jó', lastChanged: '2026-03-08', note: 'Lengéscsillapítók és szilentek normál állapotban' },
        brakes: { status: 'Megfelelő', lastChanged: '2026-09-16', note: 'Hátsó fékbetétek középtávon cserések lehetnek' },
        oilChange: { status: 'Kiváló', lastChanged: '2026-02-04', note: '5W-30 olaj, olajszűrő, levegőszűrő cserélve' },
        timingService: { status: 'Jó', lastChanged: '2026-11-21', note: 'Vezérműszíj és vízpumpa cserélve 61 000 km-nél' },
        brakeFluid: { status: 'Jó', lastChanged: '2026-09-16', note: 'Fékolaj forráspont ellenőrizve, érték rendben' },
        other: { status: 'Jó', lastChanged: '2026-03-08', note: 'DPF telítettség normál tartományban' },
    },
    '3': {
        tires: {
            frontLeft: { status: 'Kiváló', treadDepthMm: '7,0', lastChanged: '2026-10-24', note: 'Pirelli prémium nyári gumi' },
            frontRight: { status: 'Kiváló', treadDepthMm: '7,0', lastChanged: '2026-10-24', note: 'Pirelli prémium nyári gumi' },
            rearLeft: { status: 'Kiváló', treadDepthMm: '6,8', lastChanged: '2026-10-24', note: 'Pirelli prémium nyári gumi' },
            rearRight: { status: 'Kiváló', treadDepthMm: '6,8', lastChanged: '2026-10-24', note: 'Pirelli prémium nyári gumi' },
        },
        suspension: { status: 'Kiváló', lastChanged: '2026-01-30', note: 'Futómű diagnosztika hibamentes' },
        brakes: { status: 'Jó', lastChanged: '2026-01-30', note: 'Gyári féktárcsák, betétek kb. 75%-os állapotban' },
        oilChange: { status: 'Kiváló', lastChanged: '2026-01-30', note: 'BMW Longlife-04 olaj és szűrők cserélve' },
        timingService: { status: 'Kiváló', lastChanged: '2026-01-30', note: 'Láncos vezérlés, diagnosztika szerint rendben' },
        brakeFluid: { status: 'Kiváló', lastChanged: '2026-01-30', note: 'Fékolaj csere elvégezve' },
        other: { status: 'Kiváló', lastChanged: '2026-01-30', note: 'Automata váltó működése finom, hibakód nincs' },
    },
    '4': {
        tires: {
            frontLeft: { status: 'Jó', treadDepthMm: '5,8', lastChanged: '2026-04-09', note: 'Négyévszakos gumi, normál kopás' },
            frontRight: { status: 'Jó', treadDepthMm: '5,7', lastChanged: '2026-04-09', note: 'Négyévszakos gumi, normál kopás' },
            rearLeft: { status: 'Jó', treadDepthMm: '6,0', lastChanged: '2026-04-09', note: 'Négyévszakos gumi, normál kopás' },
            rearRight: { status: 'Jó', treadDepthMm: '5,9', lastChanged: '2026-04-09', note: 'Négyévszakos gumi, normál kopás' },
        },
        suspension: { status: 'Megfelelő', lastChanged: '2026-03-22', note: 'Jobb első stabilizátor pálca cserélve, futómű beállítva' },
        brakes: { status: 'Jó', lastChanged: '2026-12-02', note: 'Első fékbetétek cserélve' },
        oilChange: { status: 'Kiváló', lastChanged: '2026-03-22', note: '5W-30 olaj és szűrők cserélve' },
        timingService: { status: 'Kiváló', lastChanged: '2026-03-22', note: 'Láncos vezérlés, ellenőrzés alapján rendben' },
        brakeFluid: { status: 'Jó', lastChanged: '2026-12-02', note: 'Fékolaj csere igazolt' },
        other: { status: 'Jó', lastChanged: '2026-03-22', note: 'Klíma fertőtlenítve, pollenszűrő cserélve' },
    },
};
const cloneConditionEntry = (entry) => ({ ...entry });
const cloneConditionSheet = (sheet) => ({
    tires: {
        frontLeft: cloneConditionEntry(sheet.tires.frontLeft),
        frontRight: cloneConditionEntry(sheet.tires.frontRight),
        rearLeft: cloneConditionEntry(sheet.tires.rearLeft),
        rearRight: cloneConditionEntry(sheet.tires.rearRight),
    },
    suspension: cloneConditionEntry(sheet.suspension),
    brakes: cloneConditionEntry(sheet.brakes),
    oilChange: cloneConditionEntry(sheet.oilChange),
    timingService: cloneConditionEntry(sheet.timingService),
    brakeFluid: cloneConditionEntry(sheet.brakeFluid),
    other: cloneConditionEntry(sheet.other),
});
const findConditionTemplate = (car) => {
    if (car?.id && conditionSheetsById[car.id])
        return conditionSheetsById[car.id];
    const model = `${car?.marka ?? ''} ${car?.modell ?? ''}`.toLowerCase();
    if (model.includes('toyota') && model.includes('corolla'))
        return conditionSheetsById['1'];
    if (model.includes('volkswagen') && model.includes('golf'))
        return conditionSheetsById['2'];
    if (model.includes('bmw') && model.includes('320'))
        return conditionSheetsById['3'];
    if (model.includes('suzuki') && model.includes('vitara'))
        return conditionSheetsById['4'];
    return fallbackConditionSheet;
};
export const createDefaultCarConditionSheet = (car) => cloneConditionSheet(findConditionTemplate(car));
const normalizeConditionEntry = (entry) => ({
    status: entry?.status ?? 'Ismeretlen',
    lastChanged: entry?.lastChanged ?? '',
    note: entry?.note ?? '',
});
const normalizeTireConditionEntry = (entry) => ({
    ...normalizeConditionEntry(entry),
    treadDepthMm: entry?.treadDepthMm ?? '',
});
const isEmptyConditionEntry = (entry) => entry.status === 'Ismeretlen' && entry.lastChanged.trim() === '' && entry.note.trim() === '';
const isEmptyConditionSheet = (sheet) => Object.values(sheet.tires).every((entry) => isEmptyConditionEntry(entry) && entry.treadDepthMm.trim() === '') &&
    isEmptyConditionEntry(sheet.suspension) &&
    isEmptyConditionEntry(sheet.brakes) &&
    isEmptyConditionEntry(sheet.oilChange) &&
    isEmptyConditionEntry(sheet.timingService) &&
    isEmptyConditionEntry(sheet.brakeFluid) &&
    isEmptyConditionEntry(sheet.other);
export const normalizeCarConditionSheet = (sheet, car) => {
    const normalized = {
        tires: {
            frontLeft: normalizeTireConditionEntry(sheet?.tires?.frontLeft),
            frontRight: normalizeTireConditionEntry(sheet?.tires?.frontRight),
            rearLeft: normalizeTireConditionEntry(sheet?.tires?.rearLeft),
            rearRight: normalizeTireConditionEntry(sheet?.tires?.rearRight),
        },
        suspension: normalizeConditionEntry(sheet?.suspension),
        brakes: normalizeConditionEntry(sheet?.brakes),
        oilChange: normalizeConditionEntry(sheet?.oilChange),
        timingService: normalizeConditionEntry(sheet?.timingService),
        brakeFluid: normalizeConditionEntry(sheet?.brakeFluid),
        other: normalizeConditionEntry(sheet?.other),
    };
    return isEmptyConditionSheet(normalized) ? createDefaultCarConditionSheet(car) : normalized;
};
